import { useParams } from "@tanstack/react-router";

export function useTenantPath() {
  const params = useParams({ strict: false });
  const tenantSlug = (params as { tenantSlug?: string }).tenantSlug;
  return (path: string) => (tenantSlug ? `/${tenantSlug}${path}` : path);
}
